import { useQueryClient } from 'react-query'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { ThumbDown, ThumbUp } from 'blaze-ui/icons'
import { useCreateFeedback } from 'hooks/queries/useCreateFeedback'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { useOpenRatingsExtraFeedback } from 'hooks/useOpenRatingsExtraFeedback'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { filesKeys } from 'hooks/queries/files/filesKeys'
import { ToolbarMenu } from './ToolbarMenu'
import Styles from './ContentRating.module.scss'

interface ContentRatingProps {
  subjectId: number
  fileKey: string
}

export const ContentRating = ({ subjectId, fileKey }: ContentRatingProps) => {
  const queryClient = useQueryClient()
  const workspaceId = useCurrentWorkspaceId()
  const isExtraFeedbackEnabled = useFlipperFlag('ratings_extra_feedback')
  const { open: openRatingFeedback } = useOpenRatingsExtraFeedback()

  const { mutate, isLoading } = useCreateFeedback({
    onSuccess: (feedback) => {
      if (isExtraFeedbackEnabled) {
        openRatingFeedback({ feedback })
      }
      queryClient.invalidateQueries(filesKeys.detail(workspaceId, fileKey))
    },
  })

  const handleRate = (rating: 'upvote' | 'downvote') => {
    mutate({ rating, subject: { type: 'AISuggestionRequest', id: subjectId } })
  }

  return (
    <ToolbarMenu title="Rate this content">
      <div className={Styles.buttons}>
        <IconButton
          aria-label="Thumbs down"
          onPress={() => handleRate('downvote')}
          icon={() => <ThumbDown size={16} />}
          variant="secondary"
          size="md"
          isDisabled={isLoading}
        />
        <IconButton
          aria-label="Thumbs up"
          onPress={() => handleRate('upvote')}
          icon={() => <ThumbUp size={16} />}
          variant="secondary"
          size="md"
          isDisabled={isLoading}
        />
      </div>
    </ToolbarMenu>
  )
}
